import learningMaterial from 'ApiService/Teacher/learningMaterial';
import Card from 'components/card';
import InputField from 'components/fields/InputField';
import TextField from 'components/fields/TextField';
import ConfirmationModal from 'pages/Common/ConfirmationModal';
import Nodatafound from 'pages/Common/Nodatafound';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';

const MaterialLink = ({ selectedClass, courses, loadingCourses }) => {
  const [getlinks, setGetlinks] = useState([]);
  const [editingMaterial, setEditingMaterial] = useState(null);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedMaterialId, setSelectedMaterialId] = useState(null);

  const [editData, setEditData] = useState({
    title: '',
    description: '',
    Url: '',
    courseId: '',
    batchId: '',
  });

  const fetchData = async () => {
    setLoading(true);

    try {
      const payload = {
        courseId: selectedClass.courseId,
        batchId: selectedClass.batchId,
      };
      const response = await learningMaterial.getMaterialLinksByBatchAndCourse(
        payload
      );
      if (response.data.success) {
        setGetlinks(response.data.videos);
      } else {
        setGetlinks([]);
        toast.error('No attendance report found for the selected date.');
      }
    } catch (error) {
      setGetlinks([]);
    } finally {
      setLoading(false);
    }
  };

  const handleEditClick = (material) => {
    setEditingMaterial(material._id);
    setEditData({
      title: material.title,
      description: material.description,
      Url: material.Url,
      courseId: material.course,
      batchId: material.batch,
    });
    const selected = courses.find(
      (course) => course.courseId === material.course
    );
    setSelectedCourse(selected);
    // setCurrentMaterialId(material._id);
    setEditingMaterial(material._id);
    setIsEditModalOpen(false);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    if (!name) return;
    setEditData((prev) => ({ ...prev, [name]: value }));
  };

  const handleClassChange = (e) => {
    const courseId = e.target.value;
    const selected = courses.find((course) => course.courseId === courseId);
    setSelectedCourse(selected);
    setEditData((prev) => ({ ...prev, courseId, batchId: '' }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditData((prev) => ({ ...prev, [name]: value }));
  };

  const openEditConfirmModal = (materialId) => {
    setSelectedMaterialId(materialId);
    setIsEditModalOpen(true);
  };

  const openDeleteConfirmModal = (materialId) => {
    setSelectedMaterialId(materialId);
    setIsDeleteModalOpen(true);
  };

  const confirmEdit = async () => {
    try {
      const updatedMaterial = await learningMaterial.updateMaterialLinks(
        editData,
        selectedMaterialId
      );
      if (updatedMaterial.data.success) {
        setGetlinks((prev) =>
          prev.map((item) =>
            item._id === selectedMaterialId ? { ...item, ...editData } : item
          )
        );
        setEditingMaterial(null);
        toast.success('Material updated successfully.');
      } else {
        toast.error('Failed to update material.');
      }
    } catch (error) {
      toast.error('An error occurred while updating.');
    } finally {
      setIsEditModalOpen(false);
    }
  };

  const confirmDelete = async () => {
    try {
      const response = await learningMaterial.deleteMaterialLinks(
        selectedMaterialId
      );
      if (response.data.success) {
        setGetlinks((prev) =>
          prev.filter((item) => item._id !== selectedMaterialId)
        );
        toast.success('Material deleted successfully.');
      } else {
        toast.error('Failed to delete material.');
      }
    } catch (error) {
      toast.error('An error occurred while deleting.');
    } finally {
      setIsDeleteModalOpen(false);
    }
  };

  useEffect(() => {
    if (selectedClass.courseId && selectedClass.batchId) {
      fetchData();
    } else {
      toast('Please Select Class Details');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedClass]);

  if (loading) {
    return (
      <Card
        extra={'w-full sm:overflow-auto p-4 flex justify-center items-center'}
      >
        <div className="h-10 w-10 animate-spin rounded-full border-b-2 border-gray-900 dark:border-white"></div>
      </Card>
    );
  }

  return (
    <Card extra={'w-full sm:overflow-auto p-4'}>
      <div className="space-y-4">
        {getlinks.length === 0 ? (
          <>
            <div className="py-10 text-center text-gray-500">
              <Nodatafound title="No learning materials found for this class." />
            </div>
          </>
        ) : (
          <div className="space-y-4">
            {getlinks.map((material) => (
              <div
                key={material._id}
                className="overflow-hidden rounded-lg border border-gray-200 p-4 shadow-sm"
              >
                {editingMaterial === material._id ? (
                  <div>
                    <InputField
                      label="Title"
                      type="text"
                      name="title"
                      value={editData?.title}
                      onChange={handleFormChange}
                      className="mb-2 border p-2"
                    />
                    <TextField
                      label="Description"
                      name="description"
                      id="description"
                      value={editData?.description}
                      onChange={handleFormChange}
                      className="mb-2 w-full border p-2"
                    />
                    <InputField
                      label="Video Url"
                      type="text"
                      name="Url"
                      value={editData.Url}
                      onChange={handleFormChange}
                      className="mb-2 w-full border p-2"
                    />

                    {/* Course and Batch Select */}
                    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                      <div>
                        <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
                          Course*
                        </label>
                        <select
                          name="courseId"
                          value={editData.courseId}
                          onChange={handleClassChange}
                          className="mt-2 w-full rounded-xl border border-gray-200 p-3 text-sm outline-none dark:border-white/10 dark:bg-navy-800 dark:text-white"
                        >
                          <option value="">Select Course</option>
                          {loadingCourses ? (
                            <option>Loading courses...</option>
                          ) : courses.length === 0 ? (
                            <option className="cursor-pointer font-bold text-brand-500">
                              No courses available
                            </option>
                          ) : (
                            courses.map((course, i) => (
                              <option
                                key={course.courseId}
                                value={course.courseId}
                              >
                                {i + 1}. {course.courseName}
                              </option>
                            ))
                          )}
                        </select>
                      </div>

                      <div>
                        <label className="text-sm font-bold text-navy-700 dark:text-white">
                          Batch*
                        </label>
                        <select
                          name="batchId"
                          value={editData.batchId}
                          onChange={handleChange}
                          className="mt-2 w-full rounded-xl border border-gray-200 p-3 text-sm outline-none dark:border-white/10 dark:bg-navy-800 dark:text-white"
                        >
                          <option value="">Select Batch</option>
                          {selectedCourse?.batches.map((batch) => (
                            <option key={batch._id} value={batch._id}>
                              Batch {batch.batchNumber} -{' '}
                              {new Date(batch.startDate).toLocaleDateString()}
                              to {new Date(batch.endDate).toLocaleDateString()}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <button
                      onClick={() => openEditConfirmModal(material._id)}
                      className="mt-4 rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
                    >
                      Save
                    </button>
                    <button
                      onClick={() => setEditingMaterial(null)}
                      className="ml-4 rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-navy-700"
                    >
                      Cancel
                    </button>
                  </div>
                ) : (
                  <div>
                    <div className="flex justify-between">
                      <div>
                        <h2 className="text-lg font-semibold text-gray-800 dark:text-white">
                          {material.title}
                        </h2>
                        <p className="text-sm text-gray-600">
                          {material.description}
                        </p>
                        <a
                          href={material.Url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-sm text-blue-600 hover:underline"
                        >
                          View Material
                        </a>
                      </div>
                      <span className="text-xs text-gray-500">
                        {new Date(material.createdAt).toLocaleDateString()}
                      </span>
                    </div>
                    <div className="mt-2 flex items-center text-xs text-gray-500">
                      <span>Teacher: {material.teacher?.name}</span>
                    </div>
                    <div className="mt-3 flex space-x-2">
                      <button
                        onClick={() => handleEditClick(material)}
                        className="rounded-lg bg-blue-100 px-3 py-1 text-sm text-blue-600 hover:bg-blue-200"
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => openDeleteConfirmModal(material._id)}
                        className="rounded-lg bg-red-100 px-3 py-1 text-sm text-red-600 hover:bg-red-200"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Edit Confirmation Modal */}
      <ConfirmationModal
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        onConfirm={confirmEdit}
        title="Confirm Update"
        message="Are you sure you want to update this learning material with your changes?"
        confirmText="Yes, Update"
        cancelText="Cancel"
        icon="warning"
      />

      {/* Delete Confirmation Modal */}
      <ConfirmationModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={confirmDelete}
        title="Confirm Delete"
        message="Are you sure you want to delete this lecture link? This action cannot be undone."
        confirmText="Yes, Delete"
        cancelText="Cancel"
        icon="warning"
      />
    </Card>
  );
};

export default MaterialLink;
